export function parseList(value: string): string[] {
  return Array.from(
    new Set(
      value
        .split(/[\n,]/)
        .map((item) => item.trim())
        .filter(Boolean)
    )
  );
}

export function isScheduleExpression(value: string): boolean {
  return /^(cron|rate)\(.+\)$/.test(value.trim());
}

export function isJiraHost(value: string): boolean {
  return /^[a-z0-9.-]+\.atlassian\.net$/.test(value.trim());
}

export function isUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value.trim()
  );
}

export function isHttpsUrl(value: string): boolean {
  return /^https:\/\/[^ ]+$/.test(value.trim());
}
